"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const languageMsg = {
  MANAGE_YOUR_TEAM: 'Manage your team',
  VIEW_USERS: 'View Users',
  ADD_USERS_TO_MINE_SITES: 'Add user to <MineSiteLabelPlural>',
  SELECT_ROLE_AND_MINE_STEP: 'Select role and <MineSiteLabelPlural>',
  SEND_INVITATION_STEP: 'Send invitation',
  NEXT_LABEL: 'Next >',
  SEND_INVITATION_LABEL: 'Send invitation',
  INVITE_TEAM_MEMBERS: 'Invite team members',
  SELECT_ROLE_AND_TEAM_MEMBERS: 'Select role and team members'
};
var _default = exports.default = languageMsg;